<template>
    <div>        
        <div class="page-container" id="app-ema" >
            <div class="sidebar-menu" style="z-index:10; background:rgb(2 31 52 / 80%);"> 
                    <div class="sidebar-header" style="background:rgba(2, 31, 52, 0.3)">
                        <div class="logo"> 
                            <router-link :to="{name:'r-/'}">
                                <a>
                                    <img style="border-radius:5px;" src="@/lobato/general/img/reciclaje.jpg" alt="logo">
                                </a>
                            </router-link>
                        </div>
                    </div>
                    <div class="main-menu" style="background:rgba(2, 31, 52, 0.3)" >
                    <div class="menu-inner" id="sidebar_menu">
                        <nav>
                            
                            <ul class="metismenu" id="menu">

                                <router-link :to="{name:'r-/'}">
                                    <li class="menu-elemento" style="margin-top:1em;">
                                        <a aria-expanded="true">
                                            <i class="fa fa-home"></i>
                                            <span>Inicio</span>
                                        </a> 
                                    </li>
                                </router-link> 

                                    
                                <li class="menu-elemento-2" v-show="general.otros.app_modo=='online' && general.verificacion_rol.app.boton_datos_basicos">
                                    <!-- <a  href="javascript:void(0)" aria-expanded="true"> -->
                                    <a aria-expanded="true">
                                        <i class="fa fa-filter" aria-hidden="true"></i>
                                        <span>Datos basicos</span>
                                    </a>
                                    <ul class="collapse">
                                        <!-- <li class="menu-elemento">                                        
                                            <router-link :to="{name:'r-usuarios'}">
                                                <i class="fa fa-users" aria-hidden="true"></i>
                                                <span>Usuarios</span>
                                            </router-link> 
                                        </li>
                                        <li class="menu-elemento">                                        
                                            <router-link :to="{name:'r-clientes'}">
                                                <i class="fa fa-users" aria-hidden="true"></i>
                                                <span>Clientes</span>
                                            </router-link> 
                                        </li> -->                                            

                                        <li class="menu-elemento-2">                                            
                                            <a aria-expanded="true">
                                                <i class="fa fa-cubes" aria-hidden="true"></i>
                                                <span>Productos</span>
                                            </a>
                                            <ul class="collapse">
                                                    
                                                <li class="menu-elemento">                                        
                                                    <router-link :to="{name:'r-productos'}">
                                                        <i class="fa fa-cubes" aria-hidden="true"></i>
                                                        <span>Todos</span>
                                                    </router-link> 
                                                </li>
                                                <!-- <li class="menu-elemento">                                        
                                                    <router-link :to="{name:'r-productos/categorias'}">
                                                        <i class="fa fa-cubes" aria-hidden="true"></i>
                                                        <span>Categorias</span>
                                                    </router-link> 
                                                </li>  -->                                                   
                                                                                    
                                            </ul>
                                        </li>
                                        <!-- <li class="menu-elemento" v-show="general.verificacion_rol.app.boton_cuentas_bancarias">
                                            <router-link :to="{name:'r-cuentas_bancarias'}">
                                                <i class="fa fa-cubes" aria-hidden="true"></i>
                                                <span>Cuentas bancarias</span>
                                            </router-link> 
                                        </li> -->
                                                                                   
                                    </ul>
                                </li>
                                <li class="menu-elemento-2">
                                    <!-- <a  href="javascript:void(0)" aria-expanded="true"> -->
                                    <a aria-expanded="true">
                                        <i class="fa fa-filter" aria-hidden="true"></i>
                                        <span>Operaciones</span>
                                    </a>
                                    <ul class="collapse">
                                                                            
                                        <li class="menu-elemento" v-show="general.otros.app_modo=='online'">                                        
                                            <router-link :to="{name:'r-caja'}">
                                                <i class="fa fa-money" aria-hidden="true"></i>
                                                <span>Caja</span>
                                            </router-link> 
                                        </li>
                                        <li class="menu-elemento">                                        
                                            <router-link :to="{name:'r-compras'}">
                                                <i class="fa fa-cubes" aria-hidden="true"></i>
                                                <span>Compras</span>
                                            </router-link> 
                                        </li>
                                        <li class="menu-elemento">                                        
                                            <router-link :to="{name:'r-ventas'}">
                                                <i class="fa fa-cubes" aria-hidden="true"></i>
                                                <span>Ventas</span>
                                            </router-link> 
                                        </li>

                                        
                                        <li class="menu-elemento" v-show="general.otros.app_modo=='online'">
                                            <router-link :to="{name:'r-otros_movimientos'}">
                                                <i class="fa fa-cubes" aria-hidden="true"></i>
                                                <span>Otros movimientos</span>
                                            </router-link> 
                                        </li>

                                        <!-- <li class="menu-elemento" v-show="general.otros.app_modo=='online'">                                        
                                            <router-link :to="{name:'r-inventarios'}">
                                                <i class="fa fa-cubes" aria-hidden="true"></i>
                                                <span>Inventarios</span>
                                            </router-link> 
                                        </li> -->

                                        <!-- <li class="menu-elemento" v-show="general.otros.app_modo=='online' && general.roles.rol1">                                        
                                            <router-link :to="{name:'r-inventarios_listos'}">
                                                <i class="fa fa-cubes" aria-hidden="true"></i>
                                                <span> Traslados realizados a bodega</span>
                                            </router-link> 
                                        </li> -->

                                        
                                        <!-- <li class="menu-elemento" v-show="general.otros.app_modo=='online' && (general.roles.rol1 || general.roles.rol2)">                                        
                                            <router-link :to="{name:'r-prestamos'}">
                                                <i class="fa fa-money" aria-hidden="true"></i>
                                                <span>Prestamos</span>
                                            </router-link> 
                                        </li> -->

                                    </ul>
                                </li>
                                <li class="menu-elemento" v-show="general.otros.app_modo=='online'">                                        
                                    <router-link :to="{name:'r-inventarios'}">
                                        <i class="fa fa-cubes" aria-hidden="true"></i>
                                        <span>Inventarios</span>
                                    </router-link> 
                                </li>          



                                    
                                    

                                <li class="menu-elemento">                                        
                                    <router-link :to="{name:'r-app'}">
                                        <i class="fa fa-android" aria-hidden="true" style="margin-right:0.5em;"></i>
                                        <i class="fa fa-apple" aria-hidden="true" style="margin-right:0.5em;"></i>
                                        <span>App</span>
                                    </router-link> 
                                </li>

                            </ul>
                            

                        </nav>
                    </div>
                    </div>
            </div>
            <div class="main-content" style="background:rgba(248,244,244,0);">
                <div class="header-area" style="background:rgba(248,244,244,0);">
                    <!---<div class="row align-items-center">-->
                    <div class="row">
                        <!-- <div class="mobile-logo d_none_lg"> -->
                            <!---<a href="/">
                                    <img src="@/lobato/general/img/logo-taller-2.jpg" alt="logo">
                                </a>-->
                        <!-- </div> -->
                        <div style="z-index:11;" class="col-md-4 col-3 d_none_sm d-flex align-items-center">
                            <div class="nav-btn pull-left">
                                <span style="background:white;"></span>
                                <span style="background:white;"></span>
                                <span style="background:white;"></span>
                            </div>
                        </div>
                        <div class="col-md-3 col-5">
                            
                            <div id="contenedor-leyenda-conexion">
                            <template v-if="general.otros.app_modo=='online'">

                                <template v-if="!general.otros.conexion_internet.estado">
                                    <p class="leyenda-conexion">                              
                                        <i class="fa fa-wifi" aria-hidden="true"></i>
                                        <i class='fa fa-times' aria-hidden='true'></i>
                                        Sin conexión, cambie a modo sin conexión
                                    </p>
                                </template>

                            </template>    
                            <template v-else-if="general.otros.app_modo=='offline'">

                                <template v-if="general.otros.conexion_internet.estado">                                    
                                    <p class="leyenda-conexion">
                                        <i class="fa fa-wifi" aria-hidden="true"></i>
                                        Conexión disponible, inicie sesion
                                    </p>
                                </template>
                                <p v-else class="leyenda-conexion">
                                    <i class="fa fa-wifi" aria-hidden="true"></i>
                                    <i class='fa fa-times' aria-hidden='true'></i>
                                    Sin conexión
                                </p> 

                            </template>  
                            </div>                      

                        </div>
                        <div class="col-md-5 col-4">
                            <ul id="notification_section" class="notification-area pull-right">
                                
                                <!--
                                <li>
                                    <a :href="general.otros.dominio+'/'">
                                        <i class="fa fa-bell icono-notificacion-activo" aria-hidden="true">
                                        </i> 
                                        <i class="fa fa-bell icono-notificacion" aria-hidden="true" v-else>
                                        </i>    
                                                                                                    
                                    </a>
                                </li>
                                -->
                                                                            
                                <li>
                                    <span class="nav-btn pull-left d_none_lg">
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                    </span>
                                </li>
                                <li id="full-view" class="d_none_sm">
                                    <i class="feather ft-maximize"></i>
                                </li>
                                <li id="full-view-exit" class="d_none_sm"><i class="feather ft-minimize"></i></li>
                                <li class="settings-btn d_none_sm"></li>
                                <li class="user-dropdown">
                                    <div class="dropdown">
                                        
                                        <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <span class="d_none_sm" style="text-shadow:2px 2px 10px #cfcfcf;">
                                            {{general.usuario.nombre}} {{general.usuario.apellido_paterno}} {{general.usuario.apellido_materno}}
                                                <i class="ti-angle-down"></i>
                                            </span>
                                                                            
                                            <img src="@/lobato/general/img/default.png" alt="" class="img-fluid"
                                            style="height: 70px; width: 70px;">
                                            
                                            <!---<img src="@/lobato/general/img/logo-3.jpg" alt="" class="img-fluid"
                                            style="height: 70px; width: 70px; border-radius:7px;">-->
                                            
                                        </button>
                                        
                                                                            
                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            <!-- <a class="dropdown-item"  :href="general.otros.dominio+'/logout'" onclick="event.preventDefault();document.getElementById('logout-form').submit();">
                                            <i class="ti-power-off"></i>
                                                "Cerrar sesión"
                                            </a>
                                            <form id="logout-form" :action="general.otros.dominio+'/logout'" method="POST" class="d-none">                                                
                                                <input type="hidden" name="_token" :value=general.otros.csrf>
                                            </form> -->

                                            <template v-if="general.otros.app_modo=='online'">
                                                <a v-if="general.otros.conexion_internet.estado" class="dropdown-item boton-cerrar-sesion" @click="cerrar_sesion">
                                                    <i class="ti-power-off"></i>
                                                    Cerrar sesión
                                                </a>
                                                <a v-else class="dropdown-item" @click="iniciar_sesion">
                                                    <i class="ti-power-off"></i>
                                                    Cambiar a modo sin conexión
                                                </a>
                                            </template>
                                            <template v-else-if="general.otros.app_modo=='offline'">
                                                <a v-if="general.otros.conexion_internet.estado" class="dropdown-item boton-cerrar-sesion" @click="iniciar_sesion">
                                                    <i class="ti-power-off"></i>
                                                    Iniciar sesión
                                                </a>
                                            </template>

                                            <!-- <form id="logout-form" :action="general.otros.dominio+'/logout'" method="POST" class="d-none">                                                
                                                <input type="hidden" name="_token" :value=general.otros.csrf>
                                            </form> -->

                                        </div> 
                                                                               
                                    </div>
                                </li>
                            </ul>                            
                        </div>
                    </div>
                </div>
                <div class="main-content-inner">
                    <main class="py-0" style="z-index:9; position:relative;">
                        <!-- <vista></vista> -->
                        <router-view></router-view>
                    </main> 

                    <div v-if="general.otros.autenticado===''" style="background:black; width:100vw; height:100vh; position:absolute; z-index:9999999; top:0px; left:0px; display:flex; justify-content:center; align-items:center;">                    
                        <div class="d-flex justify-content-center">
                            <div class="spinner-border text-primary" role="status" style="width:5em; height:5em;">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
            <footer>
                
                <!-- <div class="footer-area">
                <p>&copy; Copyright 2025. Todos los derechos reservados. Desarrollado por 
                <a href="http://c-developers.i-deasmx.com/" target="_blank">C-Developers</a>.</p>
                </div> -->
                

                
                <!---<svg version="1.1" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 1600 900" preserveAspectRatio="xMidYMax slice">
                    <defs>
                        <linearGradient id="bg">
                            <stop offset="0%" style="stop-color:rgba(130, 158, 249, 0.06)"></stop>
                            <stop offset="50%" style="stop-color:rgba(76, 190, 255, 0.6)"></stop>
                            <stop offset="100%" style="stop-color:rgba(115, 209, 72, 0.2)"></stop>
                        </linearGradient>
                        <path id="wave" fill="url(#bg)" d="M-363.852,502.589c0,0,236.988-41.997,505.475,0
                s371.981,38.998,575.971,0s293.985-39.278,505.474,5.859s493.475,48.368,716.963-4.995v560.106H-363.852V502.589z" />
                    </defs>
                    <g>
                        <use xlink:href='#wave' opacity=".3">
                            <animateTransform
                                attributeName="transform"
                                attributeType="XML"
                                type="translate"
                                dur="10s"
                                calcMode="spline"
                                values="270 230; -334 180; 270 230"
                                keyTimes="0; .5; 1"
                                keySplines="0.42, 0, 0.58, 1.0;0.42, 0, 0.58, 1.0"
                                repeatCount="indefinite" />
                        </use>
                        <use xlink:href='#wave' opacity=".6">
                            <animateTransform
                                attributeName="transform"
                                attributeType="XML"
                                type="translate"
                                dur="8s"
                                calcMode="spline"
                                values="-270 230;243 220;-270 230"
                                keyTimes="0; .6; 1"
                                keySplines="0.42, 0, 0.58, 1.0;0.42, 0, 0.58, 1.0"
                                repeatCount="indefinite" />
                        </use>
                        <use xlink:href='#wave' opacty=".9">
                            <animateTransform
                                attributeName="transform"
                                attributeType="XML"
                                type="translate"
                                dur="6s"
                                calcMode="spline"
                                values="0 230;-140 200;0 230"
                                keyTimes="0; .4; 1"
                                keySplines="0.42, 0, 0.58, 1.0;0.42, 0, 0.58, 1.0"
                                repeatCount="indefinite" />
                        </use>
                    </g>
                </svg>-->
                

        
        
        
            </footer>

            <!-- <div>
                <p>Taller</p>
            </div> -->        
            
        </div>                
        

    </div>

</template>

<script>
/* eslint-disable */


import { mapState } from 'vuex'
import { mapMutations } from 'vuex'


export default {
    name: 'com_general',
    props: {
        msg: String
    },
    data() {
        return {                
            datos:{
                caches:[
                    {
                        nombre:'lobato-recursos-fijos-version-2',
                        dominio:'frontend',
                        urls:[
                            'lobato/plantilla/assets/css/flag-icon.min.css',  
                            'lobato/plantilla/css/all.css',                
                            'lobato/plantilla/assets/css/style.css',
                            'librerias/bootstrap_4_6_2/bootstrap-4.6.2.min.css',
                            //'https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css',
                            'lobato/plantilla/assets/vendors/data-table/css/jquery.dataTables.css',
                            'lobato/plantilla/assets/vendors/data-table/css/dataTables.bootstrap4.min.css',                
                            'lobato/plantilla/assets/vendors/data-table/css/select.dataTables.min.css',                
                            'lobato/plantilla/assets/vendors/data-table/css/responsive.bootstrap.min.css',                
                            'lobato/plantilla/assets/vendors/data-table/css/responsive.jqueryui.min.css',                
                            'lobato/plantilla/assets/vendors/data-table/Buttons-2.2.2/css/buttons.dataTables.min.css',
                            'lobato/plantilla/js/all.js',

                            'lobato/plantilla/assets/vendors/data-table/js/jquery.dataTables.js',
                            'lobato/plantilla/assets/vendors/data-table/js/jquery.dataTables.min.js',

                            'lobato/plantilla/assets/vendors/data-table/js/dataTables.bootstrap4.min.js',
                            'lobato/plantilla/assets/vendors/data-table/js/dataTables.responsive.min.js',

                            'lobato/plantilla/assets/vendors/data-table/js/dataTables.select.min.js',
                            'lobato/plantilla/assets/vendors/data-table/js/responsive.bootstrap.min.js',

                            'lobato/plantilla/assets/vendors/data-table/Buttons-2.2.2/js/dataTables.buttons.min.js',
                            'lobato/plantilla/assets/vendors/data-table/Buttons-2.2.2/js/buttons.html5.min.js',
                            'lobato/plantilla/assets/vendors/data-table/Buttons-2.2.2/js/buttons.print.min.js',
                            'lobato/plantilla/assets/vendors/data-table/jszip/jszip.min.js',
                            'lobato/plantilla/assets/vendors/data-table/pdfmake.min.js',
                            'lobato/plantilla/assets/vendors/data-table/vfs_fonts.js',
                            'lobato/plantilla/fonts/fontawesome-webfont.woff2?v=4.6.3',
                            'lobato/plantilla/fonts/themify.woff?-fvbane',
                            'lobato/plantilla/fonts/feather.woff?t=1525787366991',
                            'img/vertab1.bc815edb.jpg',
                            'img/logo-taller-2.cbf8fdcf.jpg',
                            'img/default.7801bee7.png',
                            //'lobato/general/img/logo-3.jpg',

                            //"logo-1024x1024.png",
                            'lobato/general/img/captura-compra-venta-metales-1.png',
                            'media/sonido-success.c9d1b574.mp3',
                            'media/sonido-remover.7afc1d6a.mp3',
                            'media/sonido-agregar.86d8cbc0.mp3',
                            'media/sonido-abre.f06fc0da.mp3',
                            'lobato/general/img/logo-pwa.png',

                            'librerias/select-buscador/select-buscador.min.css',
                            'librerias/select-buscador/select-buscador.min.js'

                        ],
                        urls_completado:true
                    },
                    {
                        nombre:'lobato-pwa-version-2',
                        dominio:'frontend',
                        urls:[
                            'pwa_ema.js',
                            'manifest_ema.json',  
                            'sw_ema.js'
                        ],
                        urls_completado:true
                    },
                    {
                        nombre:'lobato-datos-version-2',
                        dominio:'backend',
                        urls:[
                            'compras/recursos',
                            'ventas/recursos'
                        ],
                        urls_completado:true
                    }
                    /*,
                    {
                        nombre:'cabsa-pwa-datos-version-19',
                        urls:[
                            'inspeccion/recursos'
                        ],
                        urls_completado:true
                    } */
                ],
                //caches_actualizando:false
            }
        }
    },
    mounted(){
        console.log('here ema 3');
        this.inicial();
        console.log('general es');
    },
    methods:{
        ...mapMutations(['funciones','alerta','verificacion_rol']),  
        
        inicial()
        {
            
            /* fetch(`${this.general.otros.dominio}/obtener_csrf`)
            .then(res=>res.json())
            .then(respuesta=>{
                console.log('csrf es');
                console.log(respuesta);
                this.general.otros.csrf=respuesta.datos.csrf;
            })
            .catch(error=>{
                //this.funciones({nombre:'alerta',estatus:'error',mensaje:`No pudo obtenerse los clientes`});
            })
            .finally( () => {

            }); */
            //this.alerta({titulo:'Iniciando',mensaje:'espere ...'});
            
            this.verificar_token();
            window.addEventListener("online", this.internet_conexion_estado );
            window.addEventListener("offline", this.internet_conexion_estado );
            this.internet_conexion_estado();

            

            this.pwa();
            //this.revisar_actualizaciones_faltantes_app();comentado
            this.obtener_permiso_notificacion();
            
        },
        evento_cerrar_menu()
        {
            Array.from(document.getElementsByClassName("menu-elemento")).forEach((item)=>{                   
                
                item.addEventListener('click',this.ocultar_menu);

            });
        },
        actualizar_pwa_datos()
        {            
            console.log('actualizando datos pwa');
            this.datos.caches.forEach((micache,index)=>{

                if(index==2)
                {
                    let conta=0;
                    let dom=micache.dominio=='frontend' ? this.general.otros.dominio : this.general.otros.dominio_server;
                    micache.urls.forEach((url)=>{

                        fetch(`${dom}/${url}`,{
                            method:'GET',
                            //body:JSON.stringify( this.datos.registro ),
                            headers:{
                                'Accept'        :'application/json',
                                'Content-Type'  :'application/json',
                                //'Authorization' :`Bearer ${this.general.otros.token}`
                                //'X-CSRF-TOKEN':this.general.otros.csrf
                            },
                            credentials: 'include',                   
                        })
                        .then( newResp => {
                            
                            if ( (newResp.clone()).status === 200) 
                            {
                                caches.open(micache.nombre)
                                .then( cache => {
                                    //cache.put( url, newResp );   
                                    cache.put(`${dom}/${url}`,newResp);                             
                                });
                            }
                            
                        })
                        .catch(err=>{                                                                
                            
                        })
                        .finally( () => { 

                            conta++;
                            if((micache.urls).length==conta)
                            {
                                setTimeout(() => {
                                    //window.print();
                                    //this.datos.caches_actualizando=false;
                                    this.actualizar_pwa_datos();
                                    //cada 1 minuto
                                    // 1000=1 seg
                                    // 10000=10 seg
                                    // 60000=60 seg = 1 min
                                    // 1200000 = 20 min

                                //}, "60000");
                                }, "1200000");
                            }

                        }); 

                    });
                
                }

            });
        },
        pwa()
        {
            try {
                window.addEventListener('beforeinstallprompt', (e) => {
                    e.preventDefault();
                    console.log('evento es');
                    console.log(e);
                    this.general.pwa.evento_instalacion_pwa=e;
                    this.general.pwa.boton_instalar.mostrar=true;
                });
            } catch (error) {

            } 
        },
        ocultar_menu()
        {
            Array.from(document.getElementsByClassName("nav-btn")).forEach((item,index)=>{                   
                if(index==0)
                {   
                    let event=new Event('click');
                    item.dispatchEvent(event);
                    console.log('evento ejecutado');
                }
            });
        },
        cerrar_sesion()
        {
            this.alerta({titulo:'Iniciando',mensaje:'espere ...'});
            fetch(`${this.general.otros.dominio_server}/general/cerrar_sesion`,{
                method:'POST',
                //body:JSON.stringify( r ),
                headers:{                    
                    'Content-Type'  :'application/json',
                    //'Authorization' : `Bearer ${this.general.otros.token}`,
                    'Accept'        : 'application/json',
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                },  
                credentials: 'include',
                    
            })
            .then(res=>res.json())
            .then(respuesta=>{
                console.log('token es');
                console.log(respuesta);
                let dt={
                    'bien':()=>{        
                        this.funciones({nombre:'alerta',estatus:'success',mensaje:``});   
                        this.general.otros.autenticado=false;
                        localStorage.removeItem('token');
                        localStorage.removeItem('app_modo');
                        //this.$router.push('/login');                        
                    }
                };

                if(respuesta.mensaje in dt )
                {
                    dt[respuesta.mensaje]();
                }       
            })
            .catch(error=>{
                //this.funciones({nombre:'alerta',estatus:'error',mensaje:`El producto no se pudo ${this.datos.registro.id=='' ? 'crear' : 'editar'}`});
                this.funciones({nombre:'alerta',estatus:'error',mensaje:``});
                //this.general.otros.autenticado=false;

            })
            .finally( () => {
                //this.datos.data_table.cargando=false;
            });
        },  
        iniciar_sesion()
        {
            this.general.otros.autenticado=false;
            localStorage.removeItem('token');
            localStorage.removeItem('app_modo');
        },
        verificar_token()
        {           
            /* let t=localStorage.getItem('token');
            this.general.otros.token = t===null ? '' : t;

            if(this.general.otros.token==='')
            {
                this.general.otros.autenticado=false;
                

            }
            else
            { */
                let a_m=localStorage.getItem('app_modo');
                this.general.otros.app_modo = a_m===null ? '' : a_m;
                if(this.general.otros.app_modo=='online')
                {

                    fetch(`${this.general.otros.dominio_server}/general/verificar_token`,{
                        method:'POST',
                        headers:{                    
                            'Content-Type'  :'application/json',
                            //'Authorization' : `Bearer ${this.general.otros.token}`
                        },
                        credentials: 'include',                   
                    })
                    .then(res => { 
                        if (res.status === 200) 
                        { 
                            //throw new Error(`Error: ${res.status}`); 
                            return res.json(); // Convertir la respuesta a JSON si el estado es 200                         
                        } 
                        else 
                        { 
                            throw new Error(`Error: ${res.status}`); 
                        }
                    })
                    .then(respuesta=>{
                        console.log('token es');
                        console.log(respuesta);
                        let dt={
                            'bien':()=>{           
                                console.log('iniciado !!!!!');
                                //this.general.otros.csrf=respuesta.csrf;
                                this.general.otros.autenticado=true;
                                this.revisar_actualizaciones_faltantes_app();
                                this.actualizar_pwa_datos();
                                this.obtener_recursos();
                            },
                            'no valido':()=>{                                
                                this.general.otros.autenticado=false;
                                localStorage.removeItem('token');
                                localStorage.removeItem('app_modo');
                                
                            }
                        };

                        if(respuesta.mensaje in dt )
                        {
                            dt[respuesta.mensaje]();
                        }       
                    })
                    .catch(error=>{
                        
                        this.general.otros.autenticado=false;
                        localStorage.removeItem('token');
                        localStorage.removeItem('app_modo');
                        /* setTimeout(() => {
                            this.verificar_token();
                        }, "5000"); */

                    })
                    .finally( () => {

                    });
                } 
                else if(this.general.otros.app_modo=='offline')
                {
                    this.general.otros.autenticado=true;
                }
                else
                {
                    this.general.otros.autenticado=false;
                    localStorage.removeItem('token');
                    localStorage.removeItem('app_modo');
                }               

            //}
    
        },      
        obtener_recursos()
        {
            fetch(`${this.general.otros.dominio_server}/general/recursos`,{
                method:'GET',
                //body:JSON.stringify( this.datos.registro ),
                headers:{
                    'Accept'        :'application/json',
                    'Content-Type'  :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                },
                credentials: 'include',  
            })
            .then(res=>res.json())
            .then(respuesta=>{
                
                console.log('recursos ');
                console.log(respuesta);
                let u=respuesta.datos.usuario[0];

                let dt={
                    administrador   :'rol1',
                    caja            :'rol2'
                };

                if(u.rol in dt)
                {
                    let r=dt[u.rol];
                    this.general.roles[r]=true;
                }

                this.general.usuario.nombre             =u.nombre;
                this.general.usuario.apellido_paterno   =u.apellido_paterno;
                this.general.usuario.apellido_materno   =u.apellido_materno;
                this.general.usuario.rol                =u.rol;                

                this.evento_cerrar_menu();
                this.verificacion_rol();

                //this.datos.data_table.registros=respuesta.datos;                
                //this.data_table_crear();
            })
            .catch(error=>{
                //this.funciones({nombre:'alerta',estatus:'error',mensaje:`No pudo obtenerse los clientes`});
            })
            .finally( () => {
                //this.datos.data_table.cargando=false;                
            });
        },
        internet_conexion_estado()
        {
            //console.log('cambio en estado de internet');
            //console.log(navigator.onLine);
            //this.datos.internet.conectado=navigator.onLine;
            this.general.otros.conexion_internet.estado=navigator.onLine;
        },
        revisar_actualizaciones_faltantes_app()
        {
            if(this.general.otros.conexion_internet.estado)
            {
                
                if(this.datos.caches.length>0)
                {
                    console.log('revisando actualizaciones faltantes');
                    /* this.funciones({
                        nombre:'cargando',
                        titulo:'Actualizando la app 123',
                        mensaje:`espere ...`
                    }); */
                

                    this.datos.caches.forEach((micache,micache_index)=>{

                        caches.keys()
                        .then(keys=>{

                            let verifi=false;
                            keys.forEach((item,index) =>{
                                                        
                                if(micache.nombre==item)
                                {
                                    verifi=true;
                                }

                            });

                            let dom=micache.dominio=='frontend' ? this.general.otros.dominio : this.general.otros.dominio_server;
                            let miheaders='';
                            if(micache.dominio=='frontend')
                            {
                                miheaders={
                                    
                                };
                            }
                            else
                            {
                                miheaders={
                                    'Accept'        :'application/json',
                                    'Content-Type'  :'application/json',
                                    //'Authorization' :`Bearer ${this.general.otros.token}`
                                    //'X-CSRF-TOKEN':this.general.otros.csrf
                                }
                            }
                            

                            if(verifi)
                            {
                                //cuando la cache fue encontrada en las caches del navegador
                                caches.open(micache.nombre)
                                .then( cache => {
                                    //cache.put( item.url, newResp ); 
                                    //console.log('2 cache es ...') ;
                                    //console.log(cache.keys());
                                    return cache.keys();
                                })
                                .then(keys2 => {
                                                
                                    if(micache.urls.length>0)
                                    {
                                        micache.urls.forEach((url,index_url)=>{
                                            let a=keys2.find((e)=> (e.url).includes(url));
                                            if(a===undefined)
                                            {
                                                console.log('actualizando faltante 1');
                                                //fetch( `${location.origin}/${url}`)                                                  
                                                //fetch( `${dom}/${url}`)
                                                fetch(`${dom}/${url}`,{
                                                    method:'GET',
                                                    //body:JSON.stringify( this.datos.registro ),
                                                    headers:miheaders,
                                                    credentials: 'include',                   
                                                })
                                                .then( newResp => {
                                                    
                                                    if ( (newResp.clone()).status === 200) 
                                                    {
                                                        caches.open(micache.nombre)
                                                        .then( cache => {
                                                            //cache.put( url, newResp );                                
                                                            cache.put(`${dom}/${url}`,newResp);
                                                        })
                                                        .finally( () => {
                                            
                                                            if(index_url==(micache.urls.length)-1)
                                                            {
                                                                //this.es_ultima_cache_evaluando(micache_index); 
                                                                this.borrar_cache_vieja(micache,micache_index);
                                                            }
                        
                                                        }); 
                                                    }
                                                    else
                                                    {
                                                        micache.urls_completado=false;
                                                        if(index_url==(micache.urls.length)-1)
                                                        {
                                                            //this.es_ultima_cache_evaluando(micache_index); 
                                                            this.borrar_cache_vieja(micache,micache_index);
                                                        }
                                                    }
                                                    
                                                })
                                                .catch(err=>{                                                                
                                                    micache.urls_completado=false;
                                                    if(index_url==(micache.urls.length)-1)
                                                    {
                                                        //this.es_ultima_cache_evaluando(micache_index); 
                                                        this.borrar_cache_vieja(micache,micache_index);
                                                    }
                                                })
                                                .finally( () => {                                                                                
                
                                                }); 
                                            }
                                            else
                                            {
                                                if(index_url==(micache.urls.length)-1)
                                                {
                                                    //this.es_ultima_cache_evaluando(micache_index); 
                                                    this.borrar_cache_vieja(micache,micache_index);
                                                }
                                            }
                                        });
                                    }
                                    else
                                    {
                                        this.borrar_cache_vieja(micache,micache_index); 
                                    }
                                    
                                })
                                .catch(err=>{                                                                
                                    //this.borrar_cache_vieja(micache,micache_index); 
                                    this.es_ultima_cache_evaluando(micache_index);
                                })
                            }
                            else
                            {
                                //cuando la cache no fue encontrada en las caches del navegador
                                if(micache.urls.length>0)
                                {
                                    micache.urls.forEach((url,index_url)=>{
                                        console.log('actualizando faltante 2');
                                        //fetch( `${location.origin}/${url}`)
                                        //fetch( `${dom}/${url}`)
                                        fetch(`${dom}/${url}`,{
                                            method:'GET',
                                            //body:JSON.stringify( this.datos.registro ),
                                            headers:miheaders,
                                            credentials: 'include',                   
                                        })
                                        .then( newResp => {
                                            
                                            if ( (newResp.clone()).status === 200) 
                                            {
                                                caches.open(micache.nombre)
                                                .then( cache => {
                                                    //cache.put( url, newResp );   
                                                    cache.put(`${dom}/${url}`,newResp);                             
                                                });
                                            }
                                            else
                                            {
                                                micache.urls_completado=false;
                                            }
                                            
                                        })
                                        .catch(err=>{                                                                
                                            micache.urls_completado=false;
                                        })
                                        .finally( () => {
                                            
                                            if(index_url==(micache.urls.length)-1)
                                            {
                                                this.borrar_cache_vieja(micache,micache_index);
                                            }

                                        }); 

                                    });
                                }
                                else
                                {
                                    this.borrar_cache_vieja(micache,micache_index);
                                }
                            }
                            
                        })
                        .catch(err=>{                                                                
                            this.es_ultima_cache_evaluando(micache_index);                        
                        })

                    });
                }

            }
        },
        borrar_cache_vieja(micache,micache_index)
        {
            caches.keys()
            .then(keys=>{

                //let verifi=false;
                let b=(micache.nombre).split('-version-');
                if(b.length==2)
                {
                    if(keys.length>0)
                    {
                        keys.forEach((item,index) =>{

                            let a=(item).split('-version-');
                            if(a.length==2)
                            {
                                //console.log('variables son');
                                //console.log(b);
                                //console.log(a);
                                if(b[0]==a[0] && b[1]!==a[1])
                                {
                                    if(micache.urls_completado)
                                    {
                                        caches.delete(item)
                                        .then((res)=>{

                                        })
                                        .catch(err=>{})
                                        .finally( () => {
                                            if(index==keys.length-1)
                                            {
                                                this.es_ultima_cache_evaluando(micache_index);
                                            }
                                        })
                                    }
                                    else
                                    {
                                        if(index==keys.length-1)
                                        {
                                            this.es_ultima_cache_evaluando(micache_index);
                                        }
                                    }
                                }
                                else
                                {
                                    if(index==keys.length-1)
                                    {
                                        this.es_ultima_cache_evaluando(micache_index);
                                    }
                                }
                            }
                            else
                            {
                                if(index==keys.length-1)
                                {
                                    this.es_ultima_cache_evaluando(micache_index);
                                }
                            }
                                                
                        });
                    }
                    else
                    {
                        this.es_ultima_cache_evaluando(micache_index);                    
                    }
                }
                else
                {
                    this.es_ultima_cache_evaluando(micache_index);                    
                }
                
            })
            .catch(err=>{
                this.es_ultima_cache_evaluando(micache_index); 
            })
            .finally( () => {
 
            });
        },
        es_ultima_cache_evaluando(micache_index)
        {
            if(micache_index==this.datos.caches.length-1)
            {
                console.log('finalizando actualizaciones faltantes');
                /*this.funciones({
                    nombre:'alerta',
                    estatus:'success',
                    mensaje:`App actualizada !`
                }); 
                setTimeout(() => {
                    location.reload();
                }, "3000");  */
            }
        },
        obtener_permiso_notificacion()
        {

            if(! window.Notification)
            {
                console.log('este navegador no soporta notificaciones');
                return;
            }

            /* if(Notification.permission==='granted')
            {
                console.log('here 3');
                //new Notification('Hola mundo! - granted');
                enviarnotificacion();
            }
            else */ 
            if(Notification.permission!=='denied' || Notification.permission==='default')
            {
                Notification.requestPermission( function( permission ) {
                    //console.log(permission);
                    if(permission==='granted')
                    {
                        //new Notification('App lista');
                        //enviarnotificacion();
                    }
                });
            }
            else
            {
                //console.log(Notification.permission);
            }
            //console.log('permiso es');
            //console.log(Notification.permission);
        }
    },
    computed: {...mapState(['general']) },
    watch: {
        'general.otros.autenticado': function (v) {
            if(v===false)
            {
                this.$router.push('/login');
            }
            else
            {
                //this.$router.push('/');
                //window.location.href = `${this.general.otros.dominio}/`;
            }
        }
    }
}
</script>

<style lang="scss">

.boton-3d-success
{
    //box-shadow: inset 3px 3px 3px rgba(255,255,255,.7), inset -2px -2px 3px rgba(0,0,0,.1), 2px 2px 10px rgba(0,0,0,.1);
    background: #589900;
    /* box-shadow: 0 5px 0 #3a6600, 0 11px 5px hsla(0, 0%, 0%, 0.5); */
    box-shadow: 0 5px 0 #3a6600, 0 8px 5px hsla(0, 0%, 0%, 0.5);
    /* text-shadow: 2px 2px 10px white; */
    color: white;
    margin-bottom: 1em;
    
    padding: 0.47rem 0.75rem;
    border-radius: 0.25rem;
    border: 1px solid transparent;
    font-weight: bold;
    text-align: center;
    vertical-align: center;
    font-size: 0.8125rem;
    line-height: 1.5;

    font-size: 0.85em;

    &:hover{
        background: #69b301;
        box-shadow: 0 5px 0 #488001, 0 11px 5px hsla(0, 0%, 0%, 0.5);
    }
}

.boton-3d-danger
{
    //box-shadow: inset 3px 3px 3px rgba(255,255,255,.7), inset -2px -2px 3px rgba(0,0,0,.1), 2px 2px 10px rgba(0,0,0,.1);
    background: #ee4715;
    /* box-shadow: 0 5px 0 #ba3c0c, 0 11px 5px hsla(0, 0%, 0%, 0.5); */
    box-shadow: 0 5px 0 #ba3c0c, 0 8px 5px hsla(0, 0%, 0%, 0.5);
    /* text-shadow: 2px 2px 10px white; */
    color: white;
    margin-bottom: 1em;

    padding: 0.47rem 0.75rem;
    border-radius: 0.25rem;
    border: 1px solid transparent;
    font-weight: bold;
    text-align: center;
    vertical-align: center;
    font-size: 0.8125rem;
    line-height: 1.5;
    font-size: 0.85em;

    &:hover{
        background: #fa4b16;
        box-shadow: 0 5px 0 #d0440d, 0 11px 5px hsla(0, 0%, 0%, 0.5);
    }
}


.boton-3d-info
{
    //box-shadow: inset 3px 3px 3px rgba(255,255,255,.7), inset -2px -2px 3px rgba(0,0,0,.1), 2px 2px 10px rgba(0,0,0,.1);
    background: #4086c4;
    /* box-shadow: 0 5px 0 #316797, 0 11px 5px hsla(0, 0%, 0%, 0.5); */
    box-shadow: 0 5px 0 #316797, 0 8px 5px hsla(0, 0%, 0%, 0.5);
    /* text-shadow: 2px 2px 10px white; */
    color: white;
    margin-bottom: 1em;

    padding: 0.47rem 0.75rem;
    border-radius: 0.25rem;
    border: 1px solid transparent;
    font-weight: 400;
    text-align: center;
    vertical-align: center;
    font-size: 0.8125rem;
    line-height: 1.5;

    &:hover{
        background: #4c9fe8;
        box-shadow: 0 5px 0 #3c7eb8, 0 11px 5px hsla(0, 0%, 0%, 0.5);
    }
}

.elemento-3d{
    background: #fefefe;
    box-shadow: 0 5px 0 #c7c7c7, 0 11px 5px hsla(0, 0%, 0%, 0.5);
    color: #495057;
    margin-bottom: 1em;

    display:flex;
    width: 100%;

    padding: 0.47rem 0.75rem;
    border-radius: 0.25rem;
    border: 1px solid transparent;
    &:focus{
        background: #fbf8f8; 
    }   
}

.boton-3d-menu{
    background: #4086c4;
    box-shadow: 0 5px 0 #316797, 0 11px 5px hsla(0, 0%, 0%, 0.5);
    color: white;
    margin-bottom: 1em;

    padding: 0.47rem 0.75rem !important;
    border-radius: 0.25rem;
    border: 1px solid transparent;
    font-weight: 400;
    text-align: center;
    vertical-align: center;
    font-size: 0.8125rem;
    line-height: 1.5;

    &:hover{
        background: #2a0165;
        box-shadow: 0 5px 0 #19013b, 0 11px 5px hsla(0, 0%, 0%, 0.5);
    }
}
.modal-3d{
    /* box-shadow:5px 5px 0 #ffffff75, 0 7px 5px hsla(0, 0%, 0%, 1); */
    box-shadow:0 5px 0 #ffffff75, 0 11px 5px hsla(0, 0%, 0%, 0.5);
    border-radius:20px;
}
.input-3d{
    /* box-shadow:3px 3px 0 #ffffff75, 0 5px 5px hsla(0, 0%, 0%, 0.5); */
    box-shadow:3px 3px 0 #ffffff75, 0 2px 5px hsla(0, 0%, 0%, 0.5);
    border-radius:8px;
    text-align:center;
}

/* ---------------------------------------- */

svg {
  /* position: absolute; */
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: block;
  background-color: #0e4166;
  background-image: linear-gradient(to bottom, rgba(14, 65, 102, 0.86), #0e4166);
}

.data-table1{
  background:transparent !important;
  color:white;
}
#tabla-registros{
  tr{
      background:transparent !important;
      color:white !important;
  }
}
#contenedor-tabla-registros{
  label{
      color:white;
  }
}
.dataTables_info{
  color:white !important;
}
.card{
    //background: rgba(2, 31, 52, 0.8);
    //background:rgb(38 67 88 / 50%);
    background:rgb(80 110 132 / 50%);
}
.breadcrumb{
  //background:transparent; 
  //background: rgba(2, 31, 52, 0.8);
  //background:rgb(38 67 88 / 50%);
  background:rgb(80 110 132 / 50%);
  //border:5px solid rgba(0,0,0,.125);
  .active{
      color:white;
  }
}
.swal2-container{
  z-index: 9999999 !important;
}

/* .icono-notificacion-activo {
  color:lime !important;
  transform-origin: center;
  animation: rotateBell 0.5s infinite alternate;
  font-size:1.5em !important;
}
.icono-notificacion {
  color:rgb(0 255 0 / 40%) !important;
  transform-origin: center;
  font-size:1.5em !important;
} */

@keyframes rotateBell {
  0% {
      transform: rotate(45deg);
  }
  100% {
      transform: rotate(-45deg);
  }
}

#menu li a{
  background: #484848;
  -webkit-box-shadow: 0 5px 0 #474747, 0 11px 5px hsla(0, 0%, 0%, 0.5);
          box-shadow: 0 5px 0 #474747, 0 11px 5px hsla(0, 0%, 0%, 0.5);
  color: white;
  margin-bottom: 1em;
  padding: 0.47rem 0.75rem !important;
  border-radius: 0.25rem;
  border: 1px solid transparent;
  font-weight: 400;
  text-align: center;
  vertical-align: center;
  font-size: 0.8125rem;
  line-height: 1.5;

  //text-shadow:2px 2px 10px #cfcfcf;
}

#menu li{
    //box-shadow:2px 2px 10px #cfcfcf;
}

#menu li a:hover{
  background: #2a0165;
  -webkit-box-shadow: 0 5px 0 #19013b, 0 11px 5px hsla(0, 0%, 0%, 0.5);
  box-shadow: 0 5px 0 #19013b, 0 11px 5px hsla(0, 0%, 0%, 0.5);
}

.boton-cerrar-sesion{
    cursor:pointer;
}

.modal-backdrop{
    z-index:1;
}

#app-ema{
    width:100%;
    background-image: url('@/lobato/general/img/fondo-2.svg');
    background-size: cover;
}

#contenedor-leyenda-conexion{

    position:absolute; 
    z-index:9;
    width:100%;
    height:100%;
    display:flex;
    flex-wrap:wrap;
    align-items:center;

    .leyenda-conexion{
        /*position:absolute; 
        z-index:9;*/ 
        width:100%; 
        text-align:center; 
        color:white;
        margin:0px;
    }
}

#menu{
    span{
        /* text-shadow: 2px 2px 10px white; */
    }
}

.breadcrumb-item{
    //text-shadow: 2px 2px 10px white;
    text-shadow:2px 2px 10px #cfcfcf;
}

/* .barra-ubicacion-nav{
    box-shadow:2px 2px 10px #cfcfcf;
    border-radius:7px;    
} */

.li-actualizar-datos{
    cursor:pointer;
    i{
        font-size:1.1em;
    }
}


</style>



